import { Skins } from "./skins";

export class Winner {
    event_id: string;
    flight: string;
    in_prize_pool: string;
    group_event_id: string;
    holes_score: string;
    holes_hcp: string;
    total_score: string;
    penalty: string;
    gross_to_par: string;
    net: string;
    holes_played: string;
    round_id: string;
    verified: string;
    group_players: string;
    event_status: string;
    status: string;
    start_hole: string;
    start_order: string;
    start_time?: any;
    round_name: string;
    position: string;
    order: string;
    winning_amount: string;
}

export class Winners {
    winner: any;
}

export class Flight {
    flight: string;
    gross_winners?: Winners;
    prize_fund: string;
    prize_fund_net: string;
    prize_fund_gross: string;
    net_winners?: Winners;
    skins?:Skins
}

export class FlightedResults {
    flight: Flight[];
    name: string;
}



